var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
import { commonAttrs } from '../../utils';
import { CFProgressIndicatorElements } from './ProgressIndicator.styles';
import { CFProgressIndicatorItem } from './ProgressIndicatorItem';
export const CFProgressIndicator = (_a) => {
    var { alternateTheme = false, current, disabled = false, total, shape = 'pills', variant = 'default' } = _a, rest = __rest(_a, ["alternateTheme", "current", "disabled", "total", "shape", "variant"]);
    const { Root } = CFProgressIndicatorElements;
    const items = useMemo(() => [...Array(total).keys()], [total]);
    return (React.createElement(Root, Object.assign({ role: 'progressbar', "aria-label": `Step ${current} of ${total}` }, commonAttrs(rest)), items.map((_, i) => (React.createElement(CFProgressIndicatorItem, { alternateTheme: alternateTheme, disabled: disabled, isCurrent: i + 1 === current, key: `${i + 1}-of-${total}`, shape: shape, variant: variant })))));
};
